/*
 More info here: https://developer.mozilla.org/en-US/docs/Web/API/performance_property
 */
export function getCurrentTime(): number {
  if (window.performance == null || window.performance.now == null) {
    return Date.now();
  }
  return window.performance.now();
}
